// import React, { useEffect, useState } from 'react';
// import * as signalR from '@microsoft/signalr';
// import { makeStyles } from '@mui/styles';
// import Badge from '@mui/material/Badge';
// import Tooltip from '@mui/material/Tooltip';
// import Backdrop from '@mui/material/Backdrop';
// // import SpeedDial from '@mui/lab/SpeedDial';
// // import SpeedDialIcon from '@mui/lab/SpeedDialIcon';
// // import SpeedDialAction from '@mui/lab/SpeedDialAction';
// import { SpeedDial, SpeedDialIcon, SpeedDialAction } from '@mui/material';
// import RecordVoiceOver from '@mui/icons-material/RecordVoiceOver';
// import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
// import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
// import Email from '@mui/icons-material/Email';
// import NearMeIcon from '@mui/icons-material/NearMe';
// import { useStateValue } from '../../../contexto/store';
// import { Link } from 'react-router-dom';
// import { obtenerTareasNotificacion } from '../../../actions/TareasAction';
// import {
//   contarDifusionesDelDia,
//   obtenerNotasNoLeidas,
// } from '../../../actions/NotasAction';
// import {
//   obtenerCobranzasNotificacion,
//   obtenerPosiblesCobrosNotificacion,
//   obtenerFacturasBajaNotificacion,
// } from '../../../actions/CobranzasAction';
// import LocalAtmIcon from '@mui/icons-material/LocalAtm';
// const useStyles = makeStyles((theme) => ({
//   speedDial: {
//     position: 'fixed',
//     bottom: 16,
//     right: 16,
//     [theme.breakpoints.up('md')]: {
//       display: 'none',
//     },
//   },
// }));
// export default function SpeedDialTooltipOpen() {
//   const classes = useStyles();
//   const [open, setOpen] = React.useState(false);
//   //eslint-disable-next-line
//   const [{ sesionUsuario }, dispatch] = useStateValue();
//   const [notificaciones, setNotificaciones] = useState(false);
//   const [cobrosNoti, setCobrosNoti] = useState(false);
//   const [notasrecibidas, setNotasRecibidas] = useState(false);
//   const [posiblesCobrosNoti, setPosibleCobrosNoti] = useState(false);
//   const [difusionesNoti, setDifusionesNoti] = useState(false);
//   const [tareasNoti, setTareasNoti] = useState(false);
//   const [facturasBajaNoti, setFacturasBajaNoti] = useState(false);
//   const [facturasPendientesDeBaja, setFacturasPendientesDeBaja] = useState(0);

//   const [tareasDelDia, setTareasDelDia] = useState(0);
//   const [posiblesCobros, setPosiblesCobros] = useState(0);
//   const [notasNoLeidas, setNotasNoLeidas] = useState(0);
//   const [difusionesDelDia, setDifusionesDelDia] = useState(0);
//   const [cobranzasAsignadas, setCobranzasAsignadas] = useState(0);

//   const actions = [
//     {
//       icon: (
//         <Link to="/tareasPrincipal" style={{ color: '#757575' }}>
//           <Badge badgeContent={tareasDelDia} color="secondary">
//             <AssignmentLateIcon />
//           </Badge>
//         </Link>
//       ),
//       name: 'Tareas del dia',
//       permiso: tareasNoti,
//     },
//     {
//       icon: (
//         <Link to="/panelPosiblesCobrosPrincipal" style={{ color: '#757575' }}>
//           <Badge badgeContent={posiblesCobros} color="secondary">
//             <AttachMoneyIcon />
//           </Badge>
//         </Link>
//       ),
//       name: 'Posibles Cobros',
//       permiso: posiblesCobrosNoti,
//     },
//     {
//       icon: (
//         <Link to="/misNotas" style={{ color: '#757575' }}>
//           <Badge badgeContent={notasNoLeidas} color="secondary">
//             <Email />
//           </Badge>
//         </Link>
//       ),
//       name: 'Notas Recibidas',
//       permiso: notasrecibidas,
//     },
//     {
//       icon: (
//         <Link to="/cobranzasAsignadas" style={{ color: '#757575' }}>
//           {' '}
//           <Badge badgeContent={cobranzasAsignadas} color="secondary">
//             <NearMeIcon />
//           </Badge>
//         </Link>
//       ),
//       name: 'Cobranzas Asignadas',
//       permiso: cobrosNoti,
//     },
//     {
//       icon: (
//         <Link to="/difusiones" style={{ color: '#757575' }}>
//           <Badge badgeContent={difusionesDelDia} color="secondary">
//             <RecordVoiceOver />
//           </Badge>
//         </Link>
//       ),
//       name: 'Difusiones del Dia',
//       permiso: difusionesNoti,
//     },
//     {
//       icon: (
//         <Link to="/panelFacturasPendientesDeBaja" style={{ color: '#757575' }}>
//           <Badge badgeContent={facturasPendientesDeBaja} color="secondary">
//             <LocalAtmIcon />
//           </Badge>
//         </Link>
//       ),
//       name: 'Facturas Pendientes de Baja',
//       permiso: facturasBajaNoti,
//     },
//   ];
//   const evaluarPermiso = (arrayrevisar, ruta) => {
//     var boolEvaluacion = false;

//     let existe = arrayrevisar.filter((pantallazo) => pantallazo.path === ruta);

//     if (existe.length > 0) {
//       boolEvaluacion = true;
//     }

//     return boolEvaluacion;
//   };
//   useEffect(() => {
//     if (sesionUsuario !== undefined && sesionUsuario.usuario !== null) {
//       const hubConnection = new signalR.HubConnectionBuilder()
//         .withUrl(
//           'http://localhost:3020/chatHub?username=' +
//             sesionUsuario.usuario.userName
//         )
//         .build();
//       hubConnection
//         .start()
//         .catch((err) => console.error('SignalR Connection Error: ', err));

//       hubConnection.on('CuentaTareas', (TAREAS) => {
//         setTareasDelDia(TAREAS.cuenta);
//       });
//       hubConnection.on('CuentaNotasNoLeidas', (NOTASNOLEIDAS) => {
//         setNotasNoLeidas(NOTASNOLEIDAS.cuenta);
//       });
//       hubConnection.on('CuentaDifusionesDelDia', (DIFUSIONESDELDIA) => {
//         setDifusionesDelDia(DIFUSIONESDELDIA.cuenta);
//       });
//       hubConnection.on('CuentaPosiblesCobros', (POSIBLESCOBROS) => {
//         setPosiblesCobros(POSIBLESCOBROS.cuenta);
//       });
//       hubConnection.on('CuentaFacturasPendientesDeBaja', (FACTURAS) => {
//         setFacturasPendientesDeBaja(FACTURAS.cuenta);
//       });


//       let objetoNoti = {
//         USUARIOASIGNADO: sesionUsuario.usuario.nombrecompleto,
//         UserName: sesionUsuario.usuario.userName,
//       };


//       /*RRR: en esta seccion se traen las notificaciones por primera vez 
//   que se inicia el sistema y/o al actualizar el sistema */
//       obtenerTareasNotificacion(objetoNoti).then((response1) => {
//         if (response1 === undefined) {
//           obtenerTareasNotificacion(objetoNoti).then((response2) => {
//             if(response2){
//             setTareasDelDia(response2.data.cuenta);
//             }
//           });
//         } else {
//           setTareasDelDia(response1.data.cuenta);
//         }
//       });

//       let objetoNotiNota = {
//         USUARIOASIGNADO: sesionUsuario.usuario.userName,
//         UserName: sesionUsuario.usuario.userName,
//       };

//       obtenerNotasNoLeidas(objetoNotiNota).then((response1) => {
//         if (response1 === undefined) {
//           obtenerNotasNoLeidas(objetoNoti).then((response2) => {
//             if(response2){
//             setNotasNoLeidas(response2.data.cuenta);
//             }
//           });
//         } else {
//           setNotasNoLeidas(response1.data.cuenta);
//         }
//       });
//       contarDifusionesDelDia().then((response1) => {
//         if (response1 === undefined) {
//           contarDifusionesDelDia().then((response2) => {
//             if(response2){
//             setDifusionesDelDia(response2.data.cuenta);
//             }
//           });
//         } else {
//           setDifusionesDelDia(response1.data.cuenta);
//         }
//       });

//       obtenerPosiblesCobrosNotificacion().then((response1) => {
//         if (response1 === undefined) {
//           obtenerPosiblesCobrosNotificacion().then((response2) => {
//             if(response2){
//             setPosiblesCobros(response2.data.cuenta);
//             }
//           });
//         } else {
//           setPosiblesCobros(response1.data.cuenta);
//         }
//       });

//       obtenerCobranzasNotificacion(objetoNoti).then((response1) => {
//         if (response1 === undefined) {
//           obtenerCobranzasNotificacion(objetoNoti).then((response2) => {
//             if(response2){
//             setCobranzasAsignadas(response2.data.cuenta);
//             }
//           });
//         } else {
//           setCobranzasAsignadas(response1.data.cuenta);
//         }
//       });

//       obtenerFacturasBajaNotificacion(objetoNoti).then((response1) => {
//         if (response1 === undefined) {
//           obtenerFacturasBajaNotificacion(objetoNoti).then((response2) => {
//             if(response2){
//             setFacturasPendientesDeBaja(response2.data.cuenta);
//             }
//           });
//         } else {
//           setFacturasPendientesDeBaja(response1.data.cuenta);
//         }
//       });

//       const VerificarPermisos = (arrPermisos) => {
//         setNotificaciones(evaluarPermiso(arrPermisos, '/notificaciones'));
//         setCobrosNoti(evaluarPermiso(arrPermisos, '/cobrosNoti'));
//         setNotasRecibidas(evaluarPermiso(arrPermisos, '/notasrecibidas'));
//         setPosibleCobrosNoti(
//           evaluarPermiso(arrPermisos, '/posiblesCobrosNoti')
//         );
//         setDifusionesNoti(evaluarPermiso(arrPermisos, '/difusionesNoti'));
//         setTareasNoti(evaluarPermiso(arrPermisos, '/tareasNoti'));
//         setFacturasBajaNoti(evaluarPermiso(arrPermisos, '/facturasBajaNoti'));
//       };

//       if(sesionUsuario.usuario.pantallasUsuario){
//         VerificarPermisos(
//           sesionUsuario.usuario.pantallasUsuario.listaPantallasRol
//         );
//       }

//     }
//   }, [sesionUsuario]);

//   const handleOpen = () => {
//     setOpen(true);
//   };

//   const handleClose = () => {
//     setOpen(false);
//   };

//   if (notificaciones) {
//     return (
//       <div className={classes.root}>
//         <Backdrop open={open} />
//         <Tooltip title="Notificaciones">
//           <SpeedDial
//             ariaLabel="SpeedDial tooltip example"
//             className={classes.speedDial}
//             icon={<SpeedDialIcon />}
//             onClose={handleClose}
//             onOpen={handleOpen}
//             open={open}
//           >
//             {actions.map((action) =>
//               action.permiso ? (
//                 <SpeedDialAction
//                   key={action.name}
//                   icon={action.icon}
//                   onClick={handleClose}
//                   tooltipTitle={action.name}
//                 />
//               ) : null
//             )}
//           </SpeedDial>
//         </Tooltip>
//       </div>
//     );
//   } else {
//     return null;
//   }
// }
import React, { useEffect, useState } from 'react';
import * as signalR from '@microsoft/signalr';
// IMPORTANTE: Eliminamos la importación de makeStyles
// import { makeStyles } from '@mui/styles';

import Badge from '@mui/material/Badge';
import Tooltip from '@mui/material/Tooltip';
import Backdrop from '@mui/material/Backdrop';

// Asegurarse que estos se importan de @mui/material (como ya lo tienes)
import { SpeedDial, SpeedDialIcon, SpeedDialAction } from '@mui/material';

// Importaciones de iconos de Material-UI v5 (siempre de @mui/icons-material)
import RecordVoiceOver from '@mui/icons-material/RecordVoiceOver';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import Email from '@mui/icons-material/Email';
import NearMeIcon from '@mui/icons-material/NearMe';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';

import { useStateValue } from '../../../contexto/store';
import { Link } from 'react-router-dom';
import { obtenerTareasNotificacion } from '../../../actions/TareasAction';
import {
  contarDifusionesDelDia,
  obtenerNotasNoLeidas,
} from '../../../actions/NotasAction';
import {
  obtenerCobranzasNotificacion,
  obtenerPosiblesCobrosNotificacion,
  obtenerFacturasBajaNotificacion,
} from '../../../actions/CobranzasAction';

// Eliminamos la definición de useStyles
// const useStyles = makeStyles((theme) => ({
//   speedDial: {
//     position: 'fixed',
//     bottom: 16,
//     right: 16,
//     [theme.breakpoints.up('md')]: {
//       display: 'none',
//     },
//   },
// }));

export default function SpeedDialTooltipOpen() {
  // Eliminamos la llamada a useStyles
  // const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  //eslint-disable-next-line
  const [{ sesionUsuario }, dispatch] = useStateValue();
  const [notificaciones, setNotificaciones] = useState(false);
  const [cobrosNoti, setCobrosNoti] = useState(false);
  const [notasrecibidas, setNotasRecibidas] = useState(false);
  const [posiblesCobrosNoti, setPosibleCobrosNoti] = useState(false);
  const [difusionesNoti, setDifusionesNoti] = useState(false);
  const [tareasNoti, setTareasNoti] = useState(false);
  const [facturasBajaNoti, setFacturasBajaNoti] = useState(false);
  const [facturasPendientesDeBaja, setFacturasPendientesDeBaja] = useState(0);

  const [tareasDelDia, setTareasDelDia] = useState(0);
  const [posiblesCobros, setPosiblesCobros] = useState(0);
  const [notasNoLeidas, setNotasNoLeidas] = useState(0);
  const [difusionesDelDia, setDifusionesDelDia] = useState(0);
  const [cobranzasAsignadas, setCobranzasAsignadas] = useState(0);

  const actions = [
    {
      icon: (
        <Link to="/tareasPrincipal" style={{ color: '#757575' }}>
          <Badge badgeContent={tareasDelDia} color="secondary">
            <AssignmentLateIcon />
          </Badge>
        </Link>
      ),
      name: 'Tareas del dia',
      permiso: tareasNoti,
    },
    {
      icon: (
        <Link to="/panelPosiblesCobrosPrincipal" style={{ color: '#757575' }}>
          <Badge badgeContent={posiblesCobros} color="secondary">
            <AttachMoneyIcon />
          </Badge>
        </Link>
      ),
      name: 'Posibles Cobros',
      permiso: posiblesCobrosNoti,
    },
    {
      icon: (
        <Link to="/misNotas" style={{ color: '#757575' }}>
          <Badge badgeContent={notasNoLeidas} color="secondary">
            <Email />
          </Badge>
        </Link>
      ),
      name: 'Notas Recibidas',
      permiso: notasrecibidas,
    },
    {
      icon: (
        <Link to="/cobranzasAsignadas" style={{ color: '#757575' }}>
          {' '}
          <Badge badgeContent={cobranzasAsignadas} color="secondary">
            <NearMeIcon />
          </Badge>
        </Link>
      ),
      name: 'Cobranzas Asignadas',
      permiso: cobrosNoti,
    },
    {
      icon: (
        <Link to="/difusiones" style={{ color: '#757575' }}>
          <Badge badgeContent={difusionesDelDia} color="secondary">
            <RecordVoiceOver />
          </Badge>
        </Link>
      ),
      name: 'Difusiones del Dia',
      permiso: difusionesNoti,
    },
    // {
    //   icon: (
    //     <Link to="/panelFacturasPendientesDeBaja" style={{ color: '#757575' }}>
    //       <Badge badgeContent={facturasPendientesDeBaja} color="secondary">
    //         <LocalAtmIcon />
    //       </Badge>
    //     </Link>
    //   ),
    //   name: 'Facturas Pendientes de Baja',
    //   permiso: facturasBajaNoti,
    // },
  ];
  const evaluarPermiso = (arrayrevisar, ruta) => {
    var boolEvaluacion = false;

    let existe = arrayrevisar.filter((pantallazo) => pantallazo.path === ruta);

    if (existe.length > 0) {
      boolEvaluacion = true;
    }

    return boolEvaluacion;
  };
  useEffect(() => {
    if (sesionUsuario !== undefined && sesionUsuario.usuario !== null) {
      const hubConnection = new signalR.HubConnectionBuilder()
        .withUrl(
          'http://localhost:19405/chatHub?username=' +
            sesionUsuario.usuario.userName
        )
        .build();
      hubConnection
        .start()
        .catch((err) => console.error('SignalR Connection Error: ', err));

      hubConnection.on('CuentaTareas', (TAREAS) => {
        setTareasDelDia(TAREAS.cuenta);
      });
      hubConnection.on('CuentaNotasNoLeidas', (NOTASNOLEIDAS) => {
        setNotasNoLeidas(NOTASNOLEIDAS.cuenta);
      });
      hubConnection.on('CuentaDifusionesDelDia', (DIFUSIONESDELDIA) => {
        setDifusionesDelDia(DIFUSIONESDELDIA.cuenta);
      });
      hubConnection.on('CuentaPosiblesCobros', (POSIBLESCOBROS) => {
        setPosiblesCobros(POSIBLESCOBROS.cuenta);
      });
      hubConnection.on('CuentaFacturasPendientesDeBaja', (FACTURAS) => {
        setFacturasPendientesDeBaja(FACTURAS.cuenta);
      });


      let objetoNoti = {
        USUARIOASIGNADO: sesionUsuario.usuario.nombrecompleto,
        UserName: sesionUsuario.usuario.userName,
      };


      /*RRR: en esta seccion se traen las notificaciones por primera vez
      que se inicia el sistema y/o al actualizar el sistema */
      obtenerTareasNotificacion(objetoNoti).then((response1) => {
        if (response1 === undefined) {
          obtenerTareasNotificacion(objetoNoti).then((response2) => {
            if(response2){
            setTareasDelDia(response2.data.cuenta);
            }
          });
        } else {
          setTareasDelDia(response1.data.cuenta);
        }
      });

      let objetoNotiNota = {
        USUARIOASIGNADO: sesionUsuario.usuario.userName,
        UserName: sesionUsuario.usuario.userName,
      };

      obtenerNotasNoLeidas(objetoNotiNota).then((response1) => {
        if (response1 === undefined) {
          obtenerNotasNoLeidas(objetoNoti).then((response2) => {
            if(response2){
            setNotasNoLeidas(response2.data.cuenta);
            }
          });
        } else {
          setNotasNoLeidas(response1.data.cuenta);
        }
      });
      contarDifusionesDelDia().then((response1) => {
        if (response1 === undefined) {
          contarDifusionesDelDia().then((response2) => {
            if(response2){
            setDifusionesDelDia(response2.data.cuenta);
            }
          });
        } else {
          setDifusionesDelDia(response1.data.cuenta);
        }
      });

      obtenerPosiblesCobrosNotificacion().then((response1) => {
        if (response1 === undefined) {
          obtenerPosiblesCobrosNotificacion().then((response2) => {
            if(response2){
            setPosiblesCobros(response2.data.cuenta);
            }
          });
        } else {
          setPosiblesCobros(response1.data.cuenta);
        }
      });

      obtenerCobranzasNotificacion(objetoNoti).then((response1) => {
        if (response1 === undefined) {
          obtenerCobranzasNotificacion(objetoNoti).then((response2) => {
            if(response2){
            setCobranzasAsignadas(response2.data.cuenta);
            }
          });
        } else {
          setCobranzasAsignadas(response1.data.cuenta);
        }
      });

      obtenerFacturasBajaNotificacion(objetoNoti).then((response1) => {
        if (response1 === undefined) {
          obtenerFacturasBajaNotificacion(objetoNoti).then((response2) => {
            if(response2){
            setFacturasPendientesDeBaja(response2.data.cuenta);
            }
          });
        } else {
          setFacturasPendientesDeBaja(response1.data.cuenta);
        }
      });

      const VerificarPermisos = (arrPermisos) => {
        setNotificaciones(evaluarPermiso(arrPermisos, '/notificaciones'));
        setCobrosNoti(evaluarPermiso(arrPermisos, '/cobrosNoti'));
        setNotasRecibidas(evaluarPermiso(arrPermisos, '/notasrecibidas'));
        setPosibleCobrosNoti(
          evaluarPermiso(arrPermisos, '/posiblesCobrosNoti')
        );
        setDifusionesNoti(evaluarPermiso(arrPermisos, '/difusionesNoti'));
        setTareasNoti(evaluarPermiso(arrPermisos, '/tareasNoti'));
        setFacturasBajaNoti(evaluarPermiso(arrPermisos, '/facturasBajaNoti'));
      };

      if(sesionUsuario.usuario.pantallasUsuario){
        VerificarPermisos(
          sesionUsuario.usuario.pantallasUsuario.listaPantallasRol
        );
      }

    }
  }, [sesionUsuario]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  if (notificaciones) {
    return (
      // Eliminamos className={classes.root} ya que no está definido en useStyles
      <div>
        <Backdrop open={open} />
        <Tooltip title="Notificaciones">
          <SpeedDial
            ariaLabel="SpeedDial tooltip example"
            // Reemplazamos className={classes.speedDial} con la prop sx
            sx={{
              position: 'fixed',
              bottom: 16,
              right: 16,
              // Esto equivale a [theme.breakpoints.up('md')]: { display: 'none' }
              display: { xs: 'flex', md: 'none' }, // Mostrar en extra-small, ocultar en medium y superior
            }}
            icon={<SpeedDialIcon />}
            onClose={handleClose}
            onOpen={handleOpen}
            open={open}
            direction="up" // Aseguramos que la dirección esté definida si es necesaria
          >
            {actions.map((action) =>
              action.permiso ? (
                <SpeedDialAction
                  key={action.name}
                  icon={action.icon}
                  onClick={handleClose} // Aquí puedes añadir tu lógica de navegación si es necesaria
                  tooltipTitle={action.name}
                />
              ) : null
            )}
          </SpeedDial>
        </Tooltip>
      </div>
    );
  } else {
    return null;
  }
}